<template> </template>

<script>
export default {
  name: 'Security',

  components: {},
  data() {
    return {}
  },
  methods: {},

  computed: {},
  mounted() {
    this.$emit('SecurityEmit', true)
  }
}
</script>

<style lang="scss" scoped></style>
